import { useQuery } from '@tanstack/react-query';
import { requestSavedPaymentMethods, savedPaymentMethodsKey, selectCreditCards } from '../paymentApi';

/** The member's saved credit cards for the Payment Accounts page. */
export function useSavedCreditCards() {
  return useQuery({
    queryKey: savedPaymentMethodsKey,
    queryFn: requestSavedPaymentMethods,
    select: selectCreditCards,
  });
}
